class DocReady {
	constructor(fn) {
        this.init(fn);
	}
    init(fn) {
        // If we're early to the party
        document.addEventListener("DOMContentLoaded", fn);
        // If late; I mean on time.
        if (document.readyState === "interactive" || document.readyState === "complete" ) {
            fn();
        }
    }
}	

/* test
    domReady(() => console.log("DOM is ready, come and get it!"));
*/
export default DocReady;
